module.exports = __webpack_public_path__ + "static/media/img-social3.49ffe7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-social3.png
// module id = 318
// module chunks = 0